var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{on:{"click":_vm.jump}},[_vm._v(" 备案信息：宁ICP备2023000130号-1 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }